import axios from "axios"

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

const buildUrl = (path: string) => {
  if (API_BASE_URL) {
    return `${API_BASE_URL.replace(/\/$/, "")}${path}`
  }
  return path
}

export interface PagedResultDto<T> {
  items: T[]
  pageNumber: number
  pageSize: number
  totalItems: number
  totalPages: number
}

export type MailTemplateCategory = "APPROVAL" | "REVISE" | "NOTIFICATION"
export type MailTemplateStatusFilter = "all" | "active" | "inactive"

export interface MailTemplateDto {
  mailId: string
  mailCode: string
  mailName: string
  tenantId?: string | null
  category: MailTemplateCategory
  subject: string
  body: string
  isActive: boolean
}

export interface MailTemplateUpsertRequest {
  tenantId: string
  mailCode: string
  mailName: string
  category: MailTemplateCategory
  subject: string
  body: string
  isActive: boolean
}

export interface SearchMailTemplatesParams {
  tenantId: string
  search?: string
  category?: MailTemplateCategory | "all"
  status?: MailTemplateStatusFilter
  page?: number
  pageSize?: number
}

export async function searchMailTemplates({
  tenantId,
  search,
  category,
  status = "all",
  page = 1,
  pageSize = 20,
}: SearchMailTemplatesParams): Promise<PagedResultDto<MailTemplateDto>> {
  const response = await axios.get<PagedResultDto<MailTemplateDto>>(buildUrl("/api/v1/mail-templates"), {
    params: {
      tenantId,
      search: search?.trim() || undefined,
      category: category && category !== "all" ? category : undefined,
      isActive: status === "all" ? undefined : status === "active",
      page,
      pageSize,
    },
  })
  return response.data
}

export async function createMailTemplate(payload: MailTemplateUpsertRequest): Promise<MailTemplateDto> {
  const response = await axios.post<MailTemplateDto>(buildUrl("/api/v1/mail-templates"), payload)
  return response.data
}

export async function updateMailTemplate(mailId: string, payload: MailTemplateUpsertRequest): Promise<MailTemplateDto> {
  const response = await axios.post<MailTemplateDto>(buildUrl(`/api/v1/mail-templates/${mailId}`), payload)
  return response.data
}

export async function setMailTemplateActive(mailId: string, isActive: boolean): Promise<void> {
  await axios.patch(buildUrl(`/api/v1/mail-templates/${mailId}/active`), null, {
    params: { isActive },
  })
}
